import en from "./en"
import pt from "./pt"

//let test = 'pt';

export default process.env.REACT_APP_IDIOMA === 'pt' ? pt : en
